import { gql } from "@apollo/client";

export const newComplaintRegisterMutation = gql`
mutation($input: ComplaintRegisterInput!){
  newComplaintRegister(input: $input) {
    message
    response
  }
}
`;

export const updateComplaintMutation = gql`
mutation($input: ComplaintRegisterInput!){
  updateComplaint(input: $input) {
    message
    response
  }
}
`;

export const shareComplaintReportEmailMutation = gql`
mutation($message: String!, $subject: String!, $to: String!, $pdfFile: Upload!){
  shareComplaintReportEmail(message: $message, subject: $subject, to: $to, pdfFile: $pdfFile) {
    message
  }
}
`;